import { SidenavIcon, SidenavRow } from '@app/components/layout/sidenav/base';
import { Client } from '@app/core/types/client';
import { Typography } from '@mui/material';

export function ClientInfo(p: { client: Client | null }) {
  const { client } = p;

  if (!client) {
    return null;
  }

  return (
    <SidenavRow>
      {client.logoUrl && (
        <SidenavIcon
          component="img"
          {...({
            alt: 'Client logo',
            'data-cy': 'auth-client-logo',
            src: client.logoUrl,
          } as any)}
        />
      )}
      <Typography
        component="div"
        data-cy="auth-client-name"
        sx={{
          color: '#dee2e6',
          textTransform: 'uppercase',
          fontWeight: 500,
          alignSelf: 'center',
          fontSize: '1rem',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {client.name}
      </Typography>
    </SidenavRow>
  );
}
